import { render } from "./PrintableResources.vue?vue&type=template&id=dc373fd4"
import script from "./PrintableResources.vue?vue&type=script&lang=js"
export * from "./PrintableResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__